export default {
	page: 'Stránka',
	from: 'z',
};
